import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { useBeforeunload } from 'react-beforeunload'

export default function UnsavedChangesPrompt (props) {
  const { when, title } = props
  const history = useHistory()
  const [showPrompt, setShowPrompt] = React.useState(false)
  const [currentPath, setCurrentPath] = React.useState('')

  const unblockRef = React.useRef()

  useBeforeunload((event) => {
    // when is the condition to stop the page being changed
    if (when) {
      event.preventDefault()
    }
  })

  function handleShowModal () {
    setShowPrompt(true)
  }

  function onCancel (event, reason) {
    if (reason === 'backdropClick') {
      return
    }

    setShowPrompt(false)
  }

  React.useEffect(() => {
    unblockRef.current = history.block((location) => {
      if (when) {
        setCurrentPath(location.pathname)
        handleShowModal()
        return false
      }
      return true
    })

    return () => {
      unblockRef.current && unblockRef.current()
    }
  }, [when])

  function handleConfirm () {
    if (unblockRef) {
      unblockRef.current()
    }

    setShowPrompt(false)
    history.push(currentPath)
  }

  return (
    <Dialog
      open={showPrompt}
      onClose={onCancel}>
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          There are unsaved changes. Are you sure want to leave this page?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleConfirm} autoFocus>Leave</Button>
        <Button variant="contained" color="primary" onClick={onCancel}>Stay on page</Button>
      </DialogActions>
    </Dialog>
  )
}

UnsavedChangesPrompt.propTypes = {
  title: PropTypes.string,
  when: PropTypes.bool,
  manualDisplay: PropTypes.bool
}
